<template>
	<div
		class="favorite-icon"
		@click.stop.prevent="SetFavoriteRouteName($route.name)"
	>
		<i
			:class="{
				fal: favoriteRouteName !== $route.name,
				fas: favoriteRouteName === $route.name,
			}"
			class="font-18 fa-star"
		></i>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'
	export default {
		name: 'FavoriteRoute',
		props: {
			route: {
				type: Object,
				default: null,
			},
		},
		data() {
			return {}
		},
		computed: {
			...mapGetters('system', ['favoriteRouteName']),
		},
		methods: {
			...mapActions('system', ['SetFavoriteRouteName']),
		},
	}
</script>

<style lang="scss" scoped>
	.favorite-icon {
		color: var(--newPrimaryBackgroundColor);
		cursor: pointer;

		&:hover {
			color: var(--newPrimaryHoverBackgroundColor);
		}
	}
</style>
